<template>
  <div class='role-edit-privileges'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-item
          :icon="saveIcon"
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="save"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-multi-select-form-row id="privileges" key="privileges" label="privileges" placeholder="kies privileges"
                                    :multiple="true" :options="availablePrivilegesList" :value="selectedPrivilegesList"
                                    @select="addPrivilege" @remove="removePrivilege"/>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<script lang="ts">
  import {Component} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    deanSectionTitle,
    deanSectionTitleItem,
    saveIcon,
  } from '@deanone/dean-components';
  import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import {mixins} from 'vue-class-component';
  import sideMenuAdminMixin from '@/mixins/sideMenuAdminMixin';
  import DeanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';

  @Component({
    components: {
      DeanMultiSelectFormRow,
      deanSectionTitle,
      deanSectionTitleItem,
      DeanFormRow,
      DeanTwoColumnLayout,
    },
  })
  export default class Details extends mixins(sideMenuAdminMixin) {
    // DATA
    public sideMenuTitle: string = 'Rol';
    public role: any = [];
    public selectedPrivileges: Array<{
      value: string,
      label: string,
    }> = [];
    public availablePrivileges: Array<{
      value: string,
      label: string,
    }> = [];
    public allPrivileges: Array<{
      value: string,
      label: string,
    }> = [];
    public saveIcon: any = saveIcon;

    // COMPUTED
    get headerTitle(): string {
      return 'Privileges ' + this.sideMenuTitle + ' rol aanpassen';
    }

    get availablePrivilegesList() {
      return this.availablePrivileges;
    }

    get selectedPrivilegesList() {
      this.updateAvailablePrivileges();
      return this.selectedPrivileges;
    }

    public addPrivilege(field: any) {
      this.selectedPrivileges.push(field);
      this.updateAvailablePrivileges();
    }

    public removePrivilege(field: any) {
      this.selectedPrivileges = this.selectedPrivileges.filter((privilege: any) => {
        if (privilege.value !== field.value) {
          return privilege;
        }
      });
      this.updateAvailablePrivileges();
    }

    public updateAvailablePrivileges() {
      if (this.selectedPrivileges.length <= 0) {
        this.availablePrivileges = this.allPrivileges;
        return;
      }

      const selectedPrivileges: any[] = [];

      this.selectedPrivileges.forEach((privilege: any) => {
        selectedPrivileges[privilege.value] = privilege.label;
      });

      this.availablePrivileges = this.allPrivileges.filter((privilege: any) => {
        if (selectedPrivileges[privilege.value] === undefined) {
          return privilege;
        }
      });
    }

    public save() {
      this.$store.dispatch('setLoadOverlay', true);
      const requestUrl: string = '/-/trade/api/admin.role.permissions.save';

      const requestData = {
        roleId: this.$route.params.id,
        permissions: this.selectedPrivileges.map((privilege: any) => {
          return {
            id: privilege.value,
          };
        }),
      };

      axios.post(requestUrl, requestData).then(
        (response) => {
          this.$toast(this.$store.state.main.notification.messages.dataSaved);
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      this.$store.dispatch('setLoadOverlay', true);

      const promises = [];

      promises.push(this.loadAllPrivilegeList());
      promises.push(this.loadRoleInfo());

      Promise.all(promises).finally(() => this.$store.dispatch('setLoadOverlay', false));

      this.buildSideMenuAdmin(this.sideMenuTitle, this.sideMenuRoleSection);
    }

    public loadAllPrivilegeList() {
      const url: string = '/-/trade/api/admin.permissions.list';

      axios.post(url, {
        meta: {
          startIndex: 0,
          numberOfItems: 1000,
        },
      }).then(
        (response) => {
          this.allPrivileges = response.data.data.map((privilege: any) => {
            return {
              value: privilege.id,
              label: privilege.name + ':' + privilege.action,
            };
          });
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      );
    }

    public loadRoleInfo() {
      const url: string = '/-/trade/api/admin.role.info';

      axios.post(url, {
        id: this.$route.params.id,
      }).then(
        (response) => {
          this.role.id = response.data.id;
          this.role.name = response.data.name;

          this.sideMenuTitle = 'Rol ' + response.data.name;

          this.selectedPrivileges = [];

          for (const privilege of response.data.permissions) {
            this.selectedPrivileges.push({
              value: privilege.id,
              label: privilege.name + ':' + privilege.action,
            });
          }
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      );
    }
  }
</script>

<style lang="scss" scoped>

</style>
